module.exports = __webpack_public_path__ + "static/media/PlugInToYourClerks_VideoScript_1605277258235.2281a8c6.docx";